module.exports = __webpack_public_path__ + "static/our_approach-d0183ac50e582e3257d33ca8d0edde86.svg";